module.exports = __webpack_public_path__ + "static/scale-model-of-san-francisco-california-725135ea2e3d6c8486b3147a0322f457.png";